import React from 'react';

import Brochure from './Brochure';

function BrochurePage() {
    return ( 
        <>
            <Brochure />
        </>
     );
}

export default BrochurePage;